import { useState, useEffect } from 'react'

// Tenth Gate Responsive Amendment §C.1: available space, not device branding, drives
// composition. Device identity may inform interaction details elsewhere, but it is not
// the authority for information hierarchy — an iPad in landscape gets the composition
// its width supports.
export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768)

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768)
    window.addEventListener('resize', check)
    window.addEventListener('orientationchange', check)
    return () => {
      window.removeEventListener('resize', check)
      window.removeEventListener('orientationchange', check)
    }
  }, [])

  return isMobile
}
